/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { InputAdornment, TextField, Grid, FormControl } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailSend02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ChartLineData02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { Chart01Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailOpen02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { FolderOpenIcon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MailOpenIcon } from '@hugeicons-pro/core-twotone-rounded';
//@ts-ignore
import { Cursor02Icon, TimeScheduleStrokeRounded } from '@hugeicons-pro/core-stroke-rounded';

//@ts-ignore
import { SentStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
import moment from 'moment';
// import { LineChart } from '@mui/x-charts/LineChart';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
import { getDashboardPerformanceData } from 'src/services/dashboardService';
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import LineChartComponent from './LineChartComponent';
import BarGraphComponent from './BarGraphComponent';

import { styled } from '@mui/material/styles';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import BulkEmailIcon from '../../assets/icons/BulkEmailIcon';
import ListTriggerIcon from '../../assets/icons/ListTriggerIcon';
import TriggerEmailIcon from '../../assets/icons/TriggerEmailIcon';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
    [`& .${tooltipClasses.arrow}`]: {
        display: 'none',
    },
}));

const dataset = [
    { date: moment(new Date(2025, 0, 1)).format('L'), emailSent: 5, opens: 6, clicks: 9, unsubscribes: 1 },
    { date: moment(new Date(2025, 0, 2)).format('L'), emailSent: 7, opens: 8, clicks: 6, unsubscribes: 2 },
    { date: moment(new Date(2025, 0, 3)).format('L'), emailSent: 6, opens: 7, clicks: 5, unsubscribes: 3 },
    { date: moment(new Date(2025, 0, 4)).format('L'), emailSent: 8, opens: 7, clicks: 2, unsubscribes: 4 },
    { date: moment(new Date(2025, 0, 5)).format('L'), emailSent: 4, opens: 4, clicks: 4, unsubscribes: 5 },
    { date: moment(new Date(2025, 0, 6)).format('L'), emailSent: 4, opens: 3, clicks: 7, unsubscribes: 6 },
    { date: moment(new Date(2025, 0, 7)).format('L'), emailSent: 8, opens: 8, clicks: 3, unsubscribes: 7 },
    { date: moment(new Date(2025, 0, 8)).format('L'), emailSent: 7, opens: 6, clicks: 5, unsubscribes: 8 },
    { date: moment(new Date(2025, 0, 9)).format('L'), emailSent: 8, opens: 5, clicks: 2, unsubscribes: 9 },
    { date: moment(new Date(2025, 0, 10)).format('L'), emailSent: 9, opens: 6, clicks: 3, unsubscribes: 10 },

];

const DashboardContent: React.FC = () => {

    const [fromDate, setFromDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()
    const [dashboardDateRange, setDashboardDateRange] = useState<any>()
    const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false)
    const [graphData, setGraphData] = useState<any>([]);
    const [cardData, setCardData] = useState<any>([])
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [alignment, setAlignment] = useState<string>('line');
    const [interval, setInterval] = useState<number>(0);
    const [includeTestData, setIncludeTestData] = useState<boolean>(false);

    const { user } = useSelector((state: RootState) => state.auth);

    const dateRangeRef: any = useRef(null);
    const previousDatesRef = useRef<{ fromDate: any; endDate: any }>({ fromDate: null, endDate: null });

    useEffect(() => {
        const currentDates = getLast7Days();
        setFromDate(currentDates.startDate)
        setEndDate(currentDates.endDate)

        // Initialize the previous dates ref
        previousDatesRef.current = { fromDate: currentDates.startDate, endDate: currentDates.endDate };

        getDashboardData(currentDates.startDate, currentDates.endDate)
    }, [user])

    // useEffect(() => {
    //     const handleClickOutside = (event:any): void => {
    //       if (dateRangeRef.current && !dateRangeRef.current.contains(event.target)) {
    //         setIsDateRangeOpen(false);
    //       }
    //     };
    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //       document.removeEventListener("mousedown", handleClickOutside);
    //     };
    //   }, []);
    useEffect(() => {       
        const handleClickOutside = (event: any): void => {
            if (
                isDateRangeOpen && // Only when picker is open
                dateRangeRef.current &&
                !dateRangeRef.current.contains(event.target)
            ) {
                setIsDateRangeOpen(false);
                // Check if dates have actually changed before making API call
                const datesChanged =
                    fromDate && endDate &&
                    (previousDatesRef.current.fromDate?.getTime() !== fromDate?.getTime() ||
                     previousDatesRef.current.endDate?.getTime() !== endDate?.getTime());

                if (datesChanged)  {
                    previousDatesRef.current = { fromDate, endDate };
                    getDashboardData(fromDate, endDate);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isDateRangeOpen, fromDate, endDate]);

    // Call API when includeTestData changes
    useEffect(() => {
        if (fromDate && endDate) {
            getDashboardData(fromDate, endDate);
        }
    }, [includeTestData]);

    const getDashboardData = (startDate: string, endDate: string): void => {
        setIsDataLoading(true)     
        const ClientId = user?.clientId ?? 0;
        const includeTestDatavalue  = includeTestData ? 1 : 0;
        getDashboardPerformanceData(ClientId, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'),includeTestDatavalue)
            .then(
                (res: any) => {
                    if (res.status === 200) {
                        const dataset: any = [];
                        if(res.data.data.chartCounts.length > 0) {
                        res.data.data.chartCounts.map((data: any) => {
                            dataset.push({
                                date: moment(new Date(data.day)).format("MMM DD"),
                                emailSent: data.sends,
                                opens: data.opens,
                                clicks: data.clicks,
                                unsubscribes: data.unSubscribes,
                                complaints: data.complaints
                            })
                        })
                        } else {
                            const start = moment(startDate, 'YYYY-MM-DD');
                            const end = moment(endDate, 'YYYY-MM-DD');

                            const diffInDays = moment.duration(end.diff(start)).asDays();
                            setInterval(diffInDays);

                            while (start.isSameOrBefore(end)) {
                                dataset.push({
                                    date: moment(start).format("MMM DD"),
                                    emailSent: 0,
                                    opens: 0,
                                    clicks: 0,
                                    unsubscribes: 0,
                                    complaints: 0
                                })
                                start.add(1, 'day');
                            }

                            
                        }
                        
                        
                        setGraphData(dataset)
                        setCardData(res.data.data.cardCounts)
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )
            .finally(
                () => setIsDataLoading(false)
            )
    }


    // eslint-disable-next-line @typescript-eslint/no-unused-vars


    const handleDateChange = (): void => {
        setIsDateRangeOpen(true)
        // const currentDates = getLast7Days();
        setDashboardDateRange({
            startDate: fromDate,
            endDate: endDate,
            key: 'selection'
        })

        // setFromDate(currentDates.startDate)
        // setEndDate(currentDates.endDate)
    }

    const handleDateRangeClick = (ranges: any): void => {
        setDashboardDateRange(
            {
                startDate: ranges.selection.startDate,
                endDate: dashboardDateRange.endDate && dashboardDateRange.endDate > ranges.selection.startDate ? ranges.selection.endDate !== dashboardDateRange.endDate && ranges.selection.endDate !== ranges.selection.startDate ? ranges.selection.endDate : dashboardDateRange.endDate : ranges.selection.endDate,
                key: "selection"
            }
        )



        if (ranges.selection.startDate !== ranges.selection.endDate) {
            // setIsDateRangeOpen(false)
            setFromDate(ranges.selection.startDate)
            setEndDate(ranges.selection.endDate)

            // setTimeout(() => {
            //     setIsDateRangeOpen(false);
                
            // }, 5000); // slight delay for UX

            // getDashboardData(ranges.selection.startDate, ranges.selection.endDate)
        }
    }

    const getLast7Days = (): any => {
        const now = new Date();
        const endDate = new Date(now); // Today
        const startDate = new Date();
        startDate.setDate(now.getDate() - 6); // Go back 6 days (including today, makes 7 days)

        return {
            startDate,
            endDate
        };
    };

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ): void => {
        setAlignment(newAlignment);
    };

    const control = {
        value: alignment,
        onChange: handleChange,
        exclusive: true,
    };

    let inputLabels: any = [
        { key: "emailSent", label: "Sent", color: "#3FCEE1" },
        { key: "opens", label: "Opens", color: "#5FD242" },
        { key: "clicks", label: "Clicks", color: "#4B8DF5" },
        { key: "unsubscribes", label: "Unsubscribes", color: "#3A3A3A" },
        { key: "complaints", label: "Complaints", color: "#F95050" }
    ];

    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);


    return (
        <React.Fragment>
            <div className="flex justify-between items-center mb-[20px]">
                <div>
                    <h1 className="text-2xl text-title font-semibold">Dashboard</h1>
                </div>

                <div className='flex items-center gap-4'>
                    <div className='flex items-center whitespace-nowrap'>
                        <input
                            type="checkbox"
                            id="includeTestDataCheckbox"
                            checked={includeTestData}
                            onChange={(e) => {
                                setIncludeTestData(e.target.checked);
                            }}
                            disabled={isDataLoading}
                            className="mr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        />
                        <label
                            htmlFor="includeTestDataCheckbox"
                            className={`mr-1 font-medium text-14 ${
                                isDataLoading
                                    ? 'text-[#9ca3af] cursor-not-allowed'
                                    : 'text-[#3a3a3a] cursor-pointer'
                            }`}
                        >
                            Include Test Data
                        </label>
                    </div>
                    <FormControl className='form-dropdown' fullWidth>
                        <TextField
                            id="date-range"
                            label="Date Range"
                            variant="outlined"
                            autoComplete='off'
                            ref={dateRangeRef}
                            fullWidth
                            InputProps={{
                                endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                    <HugeiconsIcon
                                        icon={Calendar03Icon}
                                        size={18}
                                        color="#3A3A3A"
                                        strokeWidth={0.5}
                                        onClick={handleDateChange}
                                    />
                                </InputAdornment>
                            }}
                            onChange={handleDateChange}
                            onFocus={handleDateChange}
                            // onBlur={() => setIsLastActivityOpen(false)}
                            value={fromDate && endDate ? `${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}` : ""}
                            sx={{width: '225px'}}
                        />
                    </FormControl>
                    {isDateRangeOpen && (
                        <div ref={dateRangeRef} style={{ position: 'absolute', zIndex: '999', right: '40px', top: '125px' }}>
                            <DateRangePicker
                                ranges={[dashboardDateRange]}
                                autoFocus={false}
                                onChange={handleDateRangeClick}
                                dateDisplayFormat={'MM/dd/yyyy'}
                                inputRanges={[]}
                                color={"#FFF5F6"}
                                rangeColors={["#D6242C"]}
                                editableDateInputs={true}
                                startDatePlaceholder={"MM/DD/YYYY"}
                                endDatePlaceholder={"MM/DD/YYYY"}
                                minDate={ninetyDaysAgo}
                                maxDate={today}
                            />
                        </div>
                    )}
                </div>
            </div>
            {
                isDataLoading ? <div className='flex justify-center items-center relative top-[40%]'><span className="loading loading-spinner text-primary"></span></div> :
                    <React.Fragment>


                        <div className='mb-[30px] dashboard-card-container'>
                            <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 14 }}>
                                <Grid item xs={4} sm={4} md={2}>
                                    <div className="box-container">
                                        <BootstrapTooltip title="Active Campaigns"><div className="title">Active Campaigns</div></BootstrapTooltip>
                                        <div className="box-count">
                                            <div className="count">{cardData.totalActiveCampaign}</div>
                                            <div className="icon bg-[#EDEDFF]">
                                                <HugeiconsIcon
                                                    icon={SentStrokeStandard}
                                                    size={24}
                                                    color="#6B6BFB"
                                                    strokeWidth={0.2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={4} sm={4} md={2}>
                                    <div className="box-container">
                                        <BootstrapTooltip title="Trigger Email"><div className="title">Trigger Email</div></BootstrapTooltip>
                                        <div className="box-count">
                                            <div className="count">{cardData.totalTriggerEmail}</div>
                                            <div className="icon bg-[#DBF7FB]">
                                                <TriggerEmailIcon/>
                                                {/* <HugeiconsIcon
                                                    icon={FolderOpenIcon}
                                                    size={24}
                                                    color="#3FCEE1"
                                                    strokeWidth={0.2}
                                                /> */}
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={4} sm={4} md={2}>
                                    <div className="box-container">
                                        <BootstrapTooltip title="Bulk Email"><div className="title">Bulk Email</div></BootstrapTooltip>
                                        <div className="box-count">
                                            <div className="count">{cardData.totalBulkEmail}</div>
                                         
                                                 <div className="icon bg-[#EDEDFF]">
                                                    <BulkEmailIcon/>
                                                  {/* <HugeiconsIcon
                                                    icon={TimeScheduleStrokeRounded}
                                                    size={24}
                                                    color="#183FF7"
                                                    strokeWidth={0.2}
                                                /> */}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                  <Grid item xs={4} sm={4} md={2}>
                                    <div className="box-container">
                                        <BootstrapTooltip title="List Trigger"><div className="title">List Trigger</div></BootstrapTooltip>
                                        <div className="box-count">
                                            <div className="count">{cardData.totalListTrigger}</div>
                                               <div className="icon bg-[#CCFFEA]">
                                                <ListTriggerIcon/>
                                              {/* <HugeiconsIcon
                                                    icon={MailOpenIcon}
                                                    size={24}
                                                    color="#06A864"
                                                    strokeWidth={0.2}
                                                /> */}
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={4} sm={4} md={2}>
                                    <div className="box-container">
                                        <BootstrapTooltip title="Sent"><div className="title">Sent</div></BootstrapTooltip>
                                        <div className="box-count">
                                            <div className="count">{cardData.totalSends}</div>
                                            <div className="icon bg-[#DBF7FB]">
                                                <HugeiconsIcon
                                                    icon={MailSend02Icon}
                                                    size={24}
                                                    color="#3FCEE1"
                                                    strokeWidth={0.2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={4} sm={4} md={2}>
                                    <div className="box-container">
                                        <BootstrapTooltip title="Opens"><div className="title">Opens</div></BootstrapTooltip>
                                        <div className="box-count">
                                            <div className="count">{cardData.totalOpens}</div>
                                            <div className="icon bg-[#DBF6D4]">
                                                <HugeiconsIcon
                                                    icon={MailOpen02Icon}
                                                    size={24}
                                                    color="#5FD242"
                                                    strokeWidth={0.2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={4} sm={4} md={2}>
                                    <div className="box-container">
                                        <BootstrapTooltip title="Clicks"><div className="title">Clicks</div></BootstrapTooltip>
                                        <div className="box-count">
                                            <div className="count">{cardData.totalClicks}</div>
                                            <div className="icon bg-[#E0ECFF]">
                                                <HugeiconsIcon
                                                    icon={Cursor02Icon}
                                                    size={24}
                                                    color="#4B8DF5"
                                                    strokeWidth={0.2}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Grid>                           
                        
                            </Grid>
                        </div>
                        <div style={{ height: "550px", width: "100%" }} className='graph-container'>
                            <div className='flex justify-between items-center relative mb-[25px] right-[30px]'>
                                <div className='graph-title'>Sending Overview</div>
                                <div>
                                    <ToggleButtonGroup size="medium" {...control} aria-label="Medium sizes">
                                        <ToggleButton value="line" aria-label="line">
                                            <HugeiconsIcon
                                                icon={ChartLineData02Icon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.2}
                                            />
                                        </ToggleButton>
                                        <ToggleButton value="bar" aria-label="bar">
                                            <HugeiconsIcon
                                                icon={Chart01Icon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.2}
                                            />
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </div>
                            {
                                alignment === 'line' ? <LineChartComponent dataset={graphData} labels={inputLabels} interval={interval} /> : <BarGraphComponent dataset={graphData} labels={inputLabels} interval={interval}/>
                            }

                        </div>
                    </React.Fragment>
            }
        </React.Fragment>
    )
}

export default DashboardContent